import React, { useEffect } from 'react';
import { PageHero } from '../components/common';
import { DesignThinkingMainTabs } from '../components/design-thinking';

const DesignThinking: React.FC = () => {
  useEffect(() => {
    document.body.classList.add('ai-design-thinking-page');
    return () => {
      document.body.classList.remove('ai-design-thinking-page');
    };
  }, []);

  return (
    <main id="main-content" role="main">
      <PageHero
        title="AI for Design Thinking"
        subtitle="Curated AI tools for each stage of the Double Diamond process: empower your creative design journey."
      />

      <DesignThinkingMainTabs />
    </main>
  );
};

export default DesignThinking;

